// API Link
const endpoint = "https://api.navieralojda.ar";

export default { endpoint };

